import angular from 'angular'

import parkRun from './park.run'
import parkRoutes from './park.routes'
import parkCtrl from './park.controller'

const name = 'routingManeuverPark'

angular.module(name, [

])
  .controller('parkCtrl', parkCtrl)
  .run(parkRun)
  .config(parkRoutes)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/park/park.module.js